if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

        let selectedId = this.form.querySelector('[name=id]').value;
        let IdValue = "data_"+selectedId;
        let variant__Qty = document.querySelector(".fancybox-inner variant-radios , .product-handle variant-radios").getAttribute(IdValue);

          if (response.status) {
           document.querySelector(".fancybox-inner .quantity__input, .product-handle .quantity__input").setAttribute('value',parseInt(variant__Qty));
             document.querySelector(".fancybox-inner .quantity__input, .product-handle .quantity__input").setAttribute('placeholder',parseInt(variant__Qty));
            this.handleErrorMessage(response.description);
            return;
          }

        // mini cart section render
        fetch('/?sections=cart-items')
        .then((response) => response.json())
        .then((data) => {
          var SectionHtml = data['cart-items'] ;
          var IDminiCart = document.getElementById("mini-cart");
          var IDminiCartMask = document.getElementById("minibag_mask");
          IDminiCart.innerHTML = SectionHtml;
          IDminiCart.classList.add("show-minibag");
          IDminiCart.classList.remove("hide-minibag");
          document.body.style.overflow = "hidden";
          IDminiCartMask.style.display = 'block';
          window._swat.initializeActionButtons('.min-cart-items', '.swym-button');
        });
        //minicart section end
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            var count = cart.item_count;

            document.getElementById("CartCount").innerHTML= count;
            var thresHold_price = document.getElementById("precentfill").getAttribute("threshold_amount");
            var cartTotal = cart.total_price;
            var cartthreshhold = parseInt(thresHold_price) * 100.00;
            var percentmainvalue = cartTotal / cartthreshhold;
            var mainPercent = percentmainvalue * 100.00 ;
            var needAmmount = Math.abs(cartTotal - cartthreshhold);

            // Get the element with id="myDIV" (a div), then get all elements with class="example" inside div
            var x = document.querySelectorAll(".w3-green");
            // Create a for loop and set the background color of all elements with class="example" in div
            var i;
            for (i = 0; i < x.length; i++) {
              x[i].style.width = mainPercent+"%";
            }

            var progress_bar_money = document.querySelectorAll(".progress-bar-money");
            // cartthreshhold =Shopify.formatMoney(cartthreshhold).replace(/\.00$/,'');
            // needAmmount = Shopify.formatMoney(needAmmount).replace(/\.00$/,'');
            var i;
            for (i = 0; i < progress_bar_money.length; i++) {
              if(cartTotal >= cartthreshhold ){
                progress_bar_money[i].innerHTML=  Shopify.formatMoney(cartthreshhold).replace(/\.00$/,'') +" Done. You are eligible for";
              }else{
                progress_bar_money[i].innerHTML= "Spend "+Shopify.formatMoney(needAmmount).replace(/\.00$/,'')+" more to receive";
              }
            }
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = 'Quantity exceeds available stock';
      }
    }
  });
}
